import { queryClient } from 'src/lib/query-client';
import { ApiBasket } from 'src/api/basketService';
import { setBasketInStorage } from 'src/utils/local-storage-versioning';

export const syncBasket = (basket: ApiBasket) => {
    queryClient.setQueryData(['basket', basket.id], basket);

    setBasketInStorage({
        id: basket.id,
        updated_date: basket.updated_date,
    });
};
